var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$tc('audit_log', 2)))]),_c('audit-log')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }